export default __webpack_public_path__ + "static/media/check-done.23218229.svg";